import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import useWindowSize from '../hooks/useWindowSize';
import CookieIcon from '@mui/icons-material/Cookie';

function CookieBanner() {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 768;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: colors.bgSecondary,
      borderTop: `1px solid ${colors.border}`,
      padding: isMobile ? '1rem' : '1.2rem 2rem',
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'flex-start' : 'center',
      gap: isMobile ? '1rem' : '2rem',
      boxShadow: '0 -4px 24px rgba(0,0,0,0.3)',
    }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.8rem', flex: 1 }}>
        <CookieIcon style={{ color: colors.accent, fontSize: 22, flexShrink: 0, marginTop: '2px' }} />
        <p style={{ color: colors.textSecondary, fontSize: isMobile ? '0.82rem' : '0.9rem', lineHeight: 1.6, margin: 0 }}>
          Utilizamos cookies propias para el funcionamiento de la plataforma. Al continuar navegando aceptas nuestra{' '}
          <a href="/privacy" style={{ color: colors.accent, textDecoration: 'none', fontWeight: '500' }}>
            política de privacidad
          </a>.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '0.8rem', flexShrink: 0, width: isMobile ? '100%' : 'auto' }}>
        <button
          onClick={handleReject}
          style={{
            flex: isMobile ? 1 : 'none',
            backgroundColor: 'transparent',
            border: `1px solid ${colors.border}`,
            color: colors.textSecondary,
            padding: '0.5rem 1.2rem',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '0.88rem',
            whiteSpace: 'nowrap',
          }}>
          Rechazar
        </button>
        <button
          onClick={handleAccept}
          style={{
            flex: isMobile ? 1 : 'none',
            backgroundColor: colors.accent,
            border: 'none',
            color: colors.accentText,
            padding: '0.5rem 1.2rem',
            borderRadius: '20px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.88rem',
            whiteSpace: 'nowrap',
          }}>
          Aceptar
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;